import { useEffect } from "react"
import { songFromArrayBuffer } from "../actions/file"
import { useSetSong } from "../actions/song"

// Parent pages allowed to push a MIDI into this editor via postMessage.
// Add any other domains that embed signal in an <iframe>.
const ALLOWED_PARENT_ORIGINS = [
  "https://songai.io",
  "https://www.songai.io",
  "https://devpages.songai.io",
  "http://localhost:5100", // local songai dev
]

// When signal is embedded as an iframe, let the host page hand a MIDI file in
// without any upload: the parent postMessages the raw bytes and we load them
// into the editor. We announce readiness so the parent knows when to send.
export const useEmbedImport = () => {
  const setSong = useSetSong()

  useEffect(() => {
    if (window.parent === window) return // not embedded

    const onMessage = (e: MessageEvent) => {
      if (!ALLOWED_PARENT_ORIGINS.includes(e.origin)) return
      if (e.data?.type !== "load-midi") return
      const buf: ArrayBuffer | undefined =
        e.data.midi instanceof ArrayBuffer ? e.data.midi : e.data.midi?.buffer
      if (!buf) return
      try {
        setSong(songFromArrayBuffer(buf, undefined, e.data.name))
      } catch (err) {
        console.error("[embed import] failed to load MIDI", err)
      }
    }

    window.addEventListener("message", onMessage)
    // Tell the parent we're ready to receive a MIDI.
    window.parent.postMessage({ type: "signal-ready" }, "*")

    return () => window.removeEventListener("message", onMessage)
  }, [setSong])
}
